<template>
  <v-dialog v-model="dialog" max-width="800px">
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <v-icon left>mdi-cloud-upload</v-icon>Import Prices
      </v-btn>
    </template>
    <v-card v-if="step == 'upload'">
      <v-card-title>Import Prices</v-card-title>
      <v-card-text>
        <v-container>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <template v-if="!loading">
            <v-layout>
              <v-flex xs12>
                To import price, please download latest export, clean product
                you don't need modify and change the price
                <br />Warning, keep the columns headers and orders
              </v-flex>
            </v-layout>
            <v-layout mt-4>
              <v-flex xs12>
                <label>
                  <b>XLSX file</b>
                  <br />
                  <input type="file" @change="processFile($event)" />
                </label>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false" text>Cancel</v-btn>
        <v-spacer />
        <v-btn @click="upload" color="primary">Upload</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="step == 'validation'">
      <v-card-title>Validation</v-card-title>
      <v-card-text>
        <v-container>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <template v-if="!loading">
            <v-layout>
              <v-flex>
                <p>This file looks correct</p>
                <p>You are about to change the price of {{ rows }} products</p>
                <p>Are you sure ?</p>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false" text>Cancel</v-btn>
        <v-spacer />
        <v-btn @click="confirm" color="primary">Confirmation</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="step == 'confirmation'">
      <v-card-title>Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <template v-if="!loading">
            <v-layout>
              <v-flex>
                <p>Your file are saved and the job are scheduled</p>
                <p>You will be notified by email when your update are done</p>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="primary">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    file: null,
    loading: false,
    step: "upload",
    rows: 0,
    job: null
  }),
  props: {
    catalogId: {
      type: Number
    }
  },
  methods: {
    ...mapActions("catalogs", ["uploadPrice", "confirmUploadPrice"]),
    processFile(event) {
      this.file = event.target.files[0];
    },
    upload() {
      if (this.file) {
        this.loading = true;
        const formData = new FormData();
        formData.append("file", this.file, this.file.name);

        this.uploadPrice({ catalogId: this.catalogId, form: formData })

          .then(data => {
            this.step = "validation";
            this.job = data.job;
            this.rows = data.rows;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    confirm() {
      if (this.job.id) {
        this.loading = true;
        this.confirmUploadPrice(this.job)
          .then(() => {
            this.step = "confirmation";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style></style>
